/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Studio_4_TitleInputs */

const en_mk_studio_4_title = /** @type {(inputs: Mk_Studio_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A handover ZIP`)
};

const id_mk_studio_4_title = /** @type {(inputs: Mk_Studio_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket serah terima ZIP`)
};

/**
* | output |
* | --- |
* | "A handover ZIP" |
*
* @param {Mk_Studio_4_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_studio_4_title = /** @type {((inputs?: Mk_Studio_4_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Studio_4_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_studio_4_title(inputs)
	return en_mk_studio_4_title(inputs)
});